import Wahanda from 'common/wahanda';
import { ShiftsAnalytics } from '../tracking';

const LANG = Wahanda.lang.settings.shifts;

export const actionGoToRota = (isHidden?: boolean, isTriggeredFromVenueModal = false) => ({
  isHidden,
  label: LANG.goToRota,
  href: Wahanda.Url.getFullUrl('team', 'rota'),
  onClick: () => {
    if (isTriggeredFromVenueModal) {
      ShiftsAnalytics.trackVenueShiftGoToRotaClick();
    } else {
      ShiftsAnalytics.trackShiftGoToRotaClick();
    }
    return true;
  },
});

export const actionAddAppointment = (
  canAddAppointment: boolean,
  onClose: () => void,
  onAddAppointment?: () => void,
) => ({
  isHidden: !canAddAppointment,
  dataTest: 'shift-action-modal-add-appointment',
  label: Wahanda.lang.consumer.dialog.buttons.newAppointment,
  onClick: () => {
    onClose();
    onAddAppointment?.();
  },
});
